import { useDispatch, useSelector } from "react-redux";
import React from "react";
import { closeConfirmSpinPopup, getGiftDataByToken, setRemainPoints } from "../../../redux/actions";
import { ConfirmPopup } from "../confirmPopup/ConfirmPopup";

export const ConfirmSpinPopup = () => {
    const dispatch = useDispatch()
    const lang = useSelector(state => state.app.currentLang)
    const gameId = useSelector(state => state.game.gameWheel.settings?.id);
    const confirmSpinPopup = useSelector(state => state.app.confirmSpinPopup);
    const confirmSpinPopupLoading = useSelector(state => state.app.confirmSpinPopupLoading);
    const price = useSelector(state => state.game.gameWheel.settings?.playPrice)
    function close() {
        dispatch(closeConfirmSpinPopup());
        dispatch(setRemainPoints(null));
    }
    function confirm(){
        dispatch(getGiftDataByToken(gameId, price))
    }
    if (!confirmSpinPopup) return (null)
    else return (
        <ConfirmPopup
            confirm={confirm}
            close={close}
            title={lang.confirm.title.wheel}
            price={price}
            loading={confirmSpinPopupLoading}>
        </ConfirmPopup>
    )
}